import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';
import getCurrentConfig from './getCurrent';

const actions = createActions({
  USER: {
    ACCEPT_INVITATION: (invitationAcceptionPayload) => ({ invitationAcceptionPayload }),
    API: {
      ACCEPT_INVITATION: apiResourceActionCreator('invitation')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(USER_RESOURCE_ENDPOINT(RESOURCES.AcceptInvitation), authToken, payload, actions.user.api.acceptInvitation)

export function* acceptInvitation({
  payload: {
    invitationAcceptionPayload
  }
}) {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(apiAction(authToken, invitationAcceptionPayload));

    const acceptInvitationResult = yield apiActionResult(actions.user.api.acceptInvitation);

    if (acceptInvitationResult.success) {
      yield put(getCurrentConfig.action.user.getCurrent());
      yield put(push({ pathname: routes.app.dashboard }));
    }
  }
}

const configuration = {
  name: 'acceptInvitation',
  action: actions,
  sagas: acceptInvitation,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isFetching: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/acceptInvitation.js